import React from 'react';

import AppBar from 'components/AppBar';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Loader from 'components/Loader';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Airline } from 'models/airlineException';

import {
  Container,
  Body,
  AirlineList as List,
  AirlinesListItem,
  AirlineLogo,
  ButtonContainer,
  Button,
  Check as CheckBox,
} from './styles';

interface Props {
  show: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  airlines: Airline[];
  selecteds: string[];
  onSave: () => void;
  onClose: () => void;
  onSelect: (airlineId: string) => void;
}

const AirlinesList = ({ show, airlines, selecteds, isLoading, isSubmitting, onSelect, onSave, onClose }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <ApplicationOverlayContent sidebar show={show} onClose={onClose}>
      <Container>
        <Mobile>
          <AppBar noGoBack rightIcon="/corporate/images/close.svg" rightAction={onClose}>
            {t('airlinesList.title')}
          </AppBar>
        </Mobile>

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Desktop>
              <ModalHeader title={t('airlinesList.title')} />
            </Desktop>

            <Body>
              <List>
                {airlines.map((line) => (
                  <AirlinesListItem key={line.id}>
                    <div>
                      <AirlineLogo airline={line.id} />
                      <p>{line.name}</p>
                    </div>
                    <CheckBox checked={selecteds.includes(line.id)} circle onChange={() => onSelect(line.id)} />
                  </AirlinesListItem>
                ))}
              </List>

              <ButtonContainer>
                <Button
                  onClick={onSave}
                  value={t('airlinesList.button')}
                  loading={isSubmitting}
                  disabled={isSubmitting}
                />
              </ButtonContainer>
            </Body>
          </>
        )}
      </Container>
    </ApplicationOverlayContent>
  );
};

export default AirlinesList;
